//import TextBookListArea from "@/pages/comp/book_order/textbook/common/list";
import { useState, useRef, useEffect } from 'react';
import ListComponent from '@/pcomponents/common/crud/list/list/list_component';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import Paging from "@/pcomponents/common/crud/list/paging/paging";
import strFunc from '@/lib/lyg/string';
import { useSelector, useDispatch } from 'react-redux';
import DateFunc from '@/lib/lyg/date_func';
import LayerPopup from '@/pcomponents/common/popup/layer/layer_popup';
import TextBookSortManagePopup from "@/pages/comp/book_order/textbook/popup/multy_modify";
import getXcolumnJson from "./xcolumn/list";
import TextBookWriteArea from "@/pages/comp/book_order/textbook/common/write";
import SearchArea from "./area/search";
import ManageBtnArea from "./area/manage_btn";

function TextBookListArea() {
  let user = useSelector((state: any) => state.user);
  const xColumnArr = getXcolumnJson();
  const ListComponentRef = useRef<any>(null);
  const listOptRef = useRef<any>({});
  const TextBookWriteAreaRef = useRef<any>(null);
  const [listOpt, setListOpt] = useState({
    ...xColumnArr.list_opt,
    select_seq: "",
    s_title_like: "",
    s_category_seq: "",
    s_sort1_seq: "",
    s_sort2_seq: "",
    s_sort3_seq: "",
    s_addon_textbook_sort: "1",
    s_addon_section: "1",
    s_addon_study: "1",
    s_addon_product: "1",
  });
  listOptRef.current = listOpt;
  const [infoArr, setInfoArr] = useState([]);
  const [countInfo, setCountInfo] = useState({ "tot": 0 });

  const [popupData, setPopupData] = useState({
    isOpen: false,
    sort: "multy_modify",
    book_seq_arr: [],
    title: "팝업",
    width: "100%",
    height: "80%",
  });

  useEffect(() => {
    list({});
  }, [user]);

  const list = (inOptObj: any) => {
    let tmp_list_opt = {
      ...listOpt,
      ...inOptObj
    };
    setListOpt(tmp_list_opt);

    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/textbook/textbook/list',
      tmp_list_opt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          setInfoArr(response.data["data"]["info_arr"]);
          setCountInfo(response.data["data"]["count_info"]);
          if (ListComponentRef.current) {
            ListComponentRef.current.setInfoArr(response.data["data"]["info_arr"]);
            setSelectbySelectedSeq({
              select_seq: tmp_list_opt.select_seq,
              info_arr: response.data["data"]["info_arr"],
            });
          }
        } else {

        }
      });
  };

  const setSelectbySelectedSeq = (inData: any) => {
    let opt_obj = {
      select_seq: "",
      info_arr: infoArr,
      ...inData
    };
    if (opt_obj.select_seq != "") {
      setTimeout(() => {
        if (ListComponentRef.current) {
          let active_row_arr: any = [];
          for (let i = 0; i < opt_obj.info_arr.length; i++) {
            let info = opt_obj.info_arr[i];
            if (info.a_seq == opt_obj.select_seq) {
              active_row_arr.push(true);
            } else {
              active_row_arr.push(false);
            }
          }
          ListComponentRef.current.set_active_row_arr(active_row_arr);
        }
      }, 100);
    }
  };

  const setWriteState = (inData: any) => {
    let opt_obj = {
      row_data: {},
      ...inData
    };
    ListComponentRef.current.set_active_row_arr([]);
    if (TextBookWriteAreaRef.current) {
      let w_is_update = false;
      if (!strFunc.is_empty(opt_obj.row_data.a_seq)) {
        w_is_update = true;
      }
      TextBookWriteAreaRef.current.setInitData({
        row_data: opt_obj.row_data,
        is_update: w_is_update,
      });
    }
  };

  const goDelete = (e: any) => {
    let selected_row = ListComponentRef.current.getSelectedRows();
    if (selected_row.length === 0) {
      alert("선택없음.");
      return false;
    }
    if (!confirm("삭제하시겠습니까?")) {
      return false;
    }
    let del_form_data = {
      "data_arr": selected_row
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/textbook/textbook/delete', del_form_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          list({});
          setWriteState({});
        } else {
          alert(response.data["msg"]);
          list({});
        }
      });
  };

  const get_textbook_by_studytitle_ajax = () => {
    if (!confirm("가져오기를 하시겠습니까?")) {
      return false;
    }

    let form_json_data = {

    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/test/comp/textbook/get_by_study', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          list({});
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const open_multy_modify_popup = (inData: any) => {
    let opt_obj = {
      selected_row: ListComponentRef.current.getSelectedRows(),
      ...inData
    };

    let select_seq_arr: any = [];
    for (let i = 0; i < opt_obj.selected_row.length; i++) {
      let info = opt_obj.selected_row[i];
      select_seq_arr.push(info.a_seq);
    }

    if (select_seq_arr.length === 0) {
      alert("선택된 항목이 없습니다.");
      return false;
    }

    let popup_sort = "multy_modify";

    setPopupData({
      ...popupData,
      book_seq_arr: select_seq_arr,
      isOpen: true,
      sort: popup_sort,
      title: "일괄수정",
    });
  };

  const rowOnClick = (rowData: any, idx: number, e: any, key: string) => {

    if (TextBookWriteAreaRef.current) {
      setListOpt({
        ...listOptRef.current,
        "select_seq": rowData["a_seq"],
      });
      setWriteState({
        row_data: rowData,
        is_update: true,
      });
    }
  };

  const customCellRenderer = (params: any) => {
    /*
    {
      "rowData":rowData,
      "idx":idx,
      "key":key,
      "value":row_val,
      "origin_val":origin_val,
    }
    */
    if (params.key === "row_view_sort1") {
      if (params.rowData.bsort1_title) {
        params.value = (
          <input type='text' value={params.rowData.bsort1_title} name="bsort1_title"
            onChange={(e: any) => { }} title={params.rowData.bsort1_title}
            style={{ width: "99%", border: 0, background: "transparent" }} />
        );
      }
    } else if (params.key === "row_view_sort2") {
      if (params.rowData.bsort2_title) {
        params.value = (
          <input type='text' value={params.rowData.bsort2_title} name="bsort2_title"
            onChange={(e: any) => { }} title={params.rowData.bsort2_title}
            style={{ width: "99%", border: 0, background: "transparent" }} />
        );
      }
    } else if (params.key === "row_view_sort3") {
      if (params.rowData.bsort3_title) {
        params.value = (
          <input type='text' value={params.rowData.bsort3_title} name="bsort3_title"
            onChange={(e: any) => { }} title={params.rowData.bsort3_title}
            style={{ width: "99%", border: 0, background: "transparent" }} />
        );
      }
    } else if (params.key === "row_view_category") {
      if (params.rowData.bcategory_title) {
        params.value = (
          <input type='text' value={params.rowData.bcategory_title} name="bcategory_title"
            onChange={(e: any) => { }} title={params.rowData.bcategory_title}
            style={{ width: "99%", border: 0, background: "transparent" }} />
        );
      }
    } else if (params.key === "row_view_stock_cnt") {
      if (params.rowData.product_info) {
        params.value = strFunc.comma(params.rowData.product_info.a_stock_cnt);
      }
    } else if (params.key === "row_view_price") {
      if (params.rowData.product_info) {
        let sum_price = parseInt(strFunc.uncomma(params.rowData.product_info.a_price));
        sum_price += parseInt(strFunc.uncomma(params.rowData.product_info.a_price_tax));

        params.value = strFunc.comma(sum_price);
      }
    } else if (params.key === "row_view_price_use") {
      if (params.rowData.product_info_use) {
        params.value = strFunc.comma(params.rowData.product_info_use.a_price);
      }
    }

    return params.value;
  };

  return (
    <div>
      <table style={{ width: "100%" }}>
        <colgroup>
          <col width={"40%"}></col>
          <col width={"*"}></col>
        </colgroup>
        <tbody>
          <tr>
            <td style={{ verticalAlign: "top", paddingRight: "10px" }}>
              <div style={{ minWidth: "500px" }}>
                <SearchArea
                  listOpt={listOpt}
                  setListOpt={setListOpt}
                  list={list}
                ></SearchArea>
                <ManageBtnArea
                  setWriteState={setWriteState}
                  goDelete={goDelete}
                  open_multy_modify_popup={open_multy_modify_popup}
                ></ManageBtnArea>
                <div className="mt-1">
                  <ListComponent
                    ref={ListComponentRef}
                    xColumnArr={{ ...xColumnArr }}
                    gridOpt={{
                      fix_left_num: xColumnArr.list_opt_arr.fix_left_num,
                      is_add_idx_num: false,
                      is_add_checkbox: true,
                      td_align: "center",
                      //height: "auto",
                      is_fix_width: true,
                      rowMultiSelectWithClick: false,
                      onGridReady: () => {

                      },

                      is_all_select_row_key: true,
                      rowOnClick: rowOnClick,
                      customCellRenderer: customCellRenderer,
                      class_name_json: {
                        table_div: "basic_list_div",
                        td_div: "row-col-div",
                        input_check: "chk_row",
                        row_input: "row-input",
                        data_row_tr: "data_row_tr",
                        active_row: "active",
                        empty_con_div: "list_empty_content_div",
                      },
                    }}
                  ></ListComponent>
                </div>
                <Paging now_page={listOpt.now_page}
                  num_per_page={listOpt.num_per_page}
                  total_rec={countInfo.tot}
                  onChangePage={(now_page: number) => { list({ now_page: now_page }); }}
                  is_view_num_per_page={true}
                  is_show_total_rec={true}
                  onChangeNumPerPage={(num_per_page: number) => { list({ now_page: 1, num_per_page: num_per_page }); }}></Paging>

                <div>
                  {/* <button className='btn btn-dark' onClick={() => { get_textbook_by_studytitle_ajax(); }}>테스트교재가져오기</button> */}
                </div>
              </div>
            </td>
            <td style={{ verticalAlign: "top" }}>
              <div style={{ minWidth: "500px" }}>
                <TextBookWriteArea
                  ref={TextBookWriteAreaRef}
                  refresh_list={(inData: any) => { list(inData); }}
                ></TextBookWriteArea>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      {popupData.isOpen &&
        <LayerPopup closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }} title={popupData.title}
          width={popupData.width} height={popupData.height} >
          {popupData.sort === "multy_modify" &&
            <TextBookSortManagePopup
              book_seq_arr={popupData.book_seq_arr}
              callbackData={(inData: any) => { }}
              refreshData={(inData: any) => { list({}); }}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}></TextBookSortManagePopup>
          }
        </LayerPopup>
      }
    </div>
  );
};
export default TextBookListArea;